/* eslint-disable prettier/prettier */
import { wblCategoryService } from "../services/wbl-category.service";

//const resource = "wblcategory";
export const wblCategory = {
  namespaced: true,
  state: {
    wblCategories: []
  },
  actions: {
    getWblCategories({ commit }) {
      //debugger;
      wblCategoryService.getWblCategories().then(wblCategories => {
        commit("setWblCategories", wblCategories);
      });
    },
  },
  mutations: {
    setWblCategories(state, wblCategories) {
      state.wblCategories = wblCategories;
    }
  }
};
